import { render, staticRenderFns } from "./ModalConfirmFinishSolution.vue?vue&type=template&id=b85f4852"
import script from "./ModalConfirmFinishSolution.vue?vue&type=script&lang=js"
export * from "./ModalConfirmFinishSolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports